interface NotificationBadgeProps {
  count: number;
  max?: number;
}

export const NotificationBadge = ({ count, max = 99 }: NotificationBadgeProps) => {
  const displayCount = count > max ? `${max}+` : count.toString();

  return (
    <span
      className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1
                 flex items-center justify-center
                 bg-primary text-white text-[10px] font-medium
                 rounded-full"
      data-testid="notification-badge"
    >
      {displayCount}
    </span>
  );
};
